import { Box, type SxProps } from '@mui/material';
import { type LiHTMLAttributes, forwardRef } from 'react';

import { MarkdownCopyToClipboard } from './CopyToClipboardButton.js';
import type { ExtraProps } from './types.js';

const LIST_SX: SxProps = {
  /**
   * Override Bootstrap's default list styles
   */
  paddingLeft: 3,
  marginBottom: 0,
  '&> * + *': {
    marginTop: 0.5,
  },
};

export const MarkdownUl = forwardRef<HTMLUListElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return <Box ref={ref} component="ul" sx={LIST_SX} {...rest} />;
});
MarkdownUl.displayName = 'MarkdownUl';

export const MarkdownOl = forwardRef<HTMLOListElement, ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return <Box ref={ref} component="ol" sx={LIST_SX} {...rest} />;
});
MarkdownOl.displayName = 'MarkdownOl';

interface MarkdownListItemProps extends LiHTMLAttributes<HTMLLIElement>, ExtraProps {
  copyControls: 'Visible' | 'Hidden';
  typographyVariant: 'body2' | 'monospace';
}

export const MarkdownListItem = forwardRef<HTMLLIElement, MarkdownListItemProps>((props, ref) => {
  const { node, children, copyControls, typographyVariant, ...rest } = props;
  return (
    <Box
      ref={ref}
      component="li"
      sx={{
        typography: typographyVariant,
        '&> ul, li': {
          marginTop: 0.5,
        },
      }}
      {...rest}
    >
      {children}
      <MarkdownCopyToClipboard content={children} mode={copyControls} />
    </Box>
  );
});
MarkdownListItem.displayName = 'MarkdownListItem';
